import type { FaireProductEntity } from "../../entity_types/product";

export const p_s46e7wm4wv: FaireProductEntity = {
  token: "p_s46e7wm4wv",
  type: "product",
  name: "Gingham Printed Tulle Tiered Tutu - Kids Clothing",
  brandToken: "b_gro99lye",
  brandName: "Sweet Wink",
  imageUrl:
    "https://cdn.faire.com/fastly/884bc0552955c73972fd48a893695a166f8c5959314fbddb5b344a74ac1ac5dd.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/27b78b16f63bc9d774377f875af0cfffb65a9d684098b1aaed05e224e06e6d9e.jpeg",
    "https://cdn.faire.com/fastly/c39f27361b99365af0b3b8234f99a4622e716f0ba9c699e214bf1f23b902fb46.jpeg",
    "https://cdn.faire.com/fastly/e0470c64a75c770463c17c754aa5260d53ae04101745a843dba6b4247cbb09ee.jpeg",
    "https://cdn.faire.com/fastly/e58b31b0fdcf4d184892b55095f44f7f8e27da235f6ff0611b426153d544e6ac.jpeg",
    "https://cdn.faire.com/fastly/f22471a1ccafec4de6e06bd259b8d659d003181d659bb530e82cd772538233af.jpeg",
    "https://cdn.faire.com/fastly/8e4a3b159f355892e899fb5591ab17f80e0e0c693a6c4073283c8951c4ea0dfc.jpeg",
    "https://cdn.faire.com/fastly/406fe0b253900cb40e2f55f7b8c963882fd437b51fedb0ec98e5a7920c2c3292.jpeg",
  ],
  priceDollars: 18,
  description:
    "The Gingham Printed Tulle Tiered Tutu is a trendy skirt and dress up tutu for the perfect Fall look!\n\nFeatures:\n*Brown and white gingham printed tulle accented with gold glitter pin dots\n*Espresso cotton lining\n*Espresso elastic waistband\n*Care: Hand wash and line dry\n\nThe Sweet Wink difference:\nSuper soft tulle that doesn’t scratch or itch\nCotton lining provides extra coverage and comfort\n“Shed-free” embellishments ensure glitter does not sprinkle around the house",
  tags: [],
  msrpDollars: 36,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:53:27.820Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
